<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">C<span class="small">ONTENTS</span></p>
<p class="toc"><a href="#/maps">Maps</a></p>
<p class="toc"><a href="#/foreword">Foreword, by Tyler Resch</a></p>
<p class="toc"><a href="#/preface">Preface</a></p>
<p class="toc1"><a href="#/chapter01">T<span class="small">HE</span> B<span class="small">ENNINGTON</span> E<span class="small">XPEDITION</span>: A<span class="small">N</span> O<span class="small">VERVIEW</span></a></p>
<p class="toc"><a href="#/chapter01#h1">Background</a></p>
<p class="toc"><a href="#/chapter01#h2">Overview of Battle</a></p>
<p class="toc"><a href="#/chapter01#h3">Raising Troops</a></p>
<p class="toc1"><span href="#/chapter02" title="Link target outside of Sample">T<span class="small">HE</span> B<span class="small">ATTLE OF</span> B<span class="small">ENNINGTON</span></span></p>
<p class="toc"><span href="#/chapter02#h1" title="Link target outside of Sample">Description of Battlefield</span></p>
<p class="toc"><span href="#/chapter02#h2" title="Link target outside of Sample">Gregg’s Skirmish</span></p>
<p class="toc"><span href="#/chapter02#h3" title="Link target outside of Sample">Nichols’s Attack</span></p>
<p class="toc"><span href="#/chapter02#h4" title="Link target outside of Sample">Herrick’s Attack</span></p>
<p class="toc"><span href="#/chapter02#h5" title="Link target outside of Sample">“Tory Redoubt”</span></p>
<p class="toc"><span href="#/chapter02#h6" title="Link target outside of Sample">Diversion in the Center</span></p>
<p class="toc"><span href="#/chapter02#h7" title="Link target outside of Sample">Fight with Breymann</span></p>
<p class="toc1"><span href="#/chapter03" title="Link target outside of Sample">O<span class="small">THER</span> A<span class="small">CCOUNTS</span></span></p>
<p class="toc"><span href="#/chapter03#h1" title="Link target outside of Sample">Loyalists</span></p>
<p class="toc"><span href="#/chapter03#h2" title="Link target outside of Sample">Cattle Ambush on the Hoosic River</span></p>
<p class="toc"><span href="#/chapter03#h3" title="Link target outside of Sample">Civilians</span></p>
<p class="toc1"><span href="#/aftermath" title="Link target outside of Sample">Aftermath</span></p>
<p class="toc"><span href="#/appendix01" title="Link target outside of Sample">Appendix A. Commemoration</span></p>
<p class="toc"><span href="#/appendix02" title="Link target outside of Sample">Appendix B. Bennington Expedition Timeline</span></p>
<p class="toc"><span href="#/appendix03" title="Link target outside of Sample">Appendix C. Key Personalities Appearing in the Accounts</span></p>
<p class="toc"><span href="#/notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/bibliography" title="Link target outside of Sample">Selected Bibliography</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?7bb202e4